module.exports = __webpack_public_path__ + "img/workShopReview_banner.21cf42a4.png";